import { ChargebacksQueueFields } from "globalConstants";
import { onlyDigits } from "validators/validation";
const { ChargebacksCount, ChargebacksCountFrom, ChargebacksCountTo } =
	ChargebacksQueueFields;

const chargebacksCount = ({ formName = "" }) => ({
	name: ChargebacksCount.name,
	type: "numeric-range" as const,
	placeholder: ChargebacksCount.displayName,
	normalize: onlyDigits,
	normalizeOnBlur: onlyDigits,
	nameInputFrom: ChargebacksCountFrom.name,
	nameInputTo: ChargebacksCountTo.name,
	title: "Please Select the Amount Range",
	formName,
	groupColumns: [
		{
			name: ChargebacksCountFrom.name,
			formatLabel: value =>
				`${ChargebacksCountFrom.displayName}: ${value}`,
		},
		{
			name: ChargebacksCountTo.name,
			formatLabel: value => `${ChargebacksCountTo.displayName}: ${value}`,
		},
	],
});

export default chargebacksCount;
